import Tracker from './Tracker';

const flowTracker = new Tracker('flow', {
	CREATE: 'create',
	START_FROM_TEMPLATE: 'startFromTemplate',
	ACTIVATE_FLOW_FROM_TEMPLATE: 'activateFlowFromTemplate'
});

export default flowTracker;
